var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"detail-info"},[_c('h2',[_vm._v("隐私协议")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.txt)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }